module.exports = __webpack_public_path__ + "img/badgesex150_40_3_white.6864e45d.png";